<script>
    export default {
        name: "AppLang",
        data(){
            return {
                alterLanguages: ['ru'],
                defaultLanguage: 'ua'
            }
        },
        methods: {
            setAppLanguage(){
                const lang = window.location.pathname.split('/')[1];

                if(lang && this.$store.state.language.appLanguages.indexOf(lang) > -1) {
                    this.$store.commit('updateAppLanguage', lang);
                }
            }
        },
        created(){
            this.setAppLanguage();
        },
    }
</script>

<style scoped>

</style>
